import PeriodResultTable, { ResultLeague } from "./PeriodResultTable";

const periodColumns = [
  { label: "Q1", type: "quarter", number: 1 },
  { label: "Q2", type: "quarter", number: 2 },
  { label: "Q3", type: "quarter", number: 3 },
  { label: "Q4", type: "quarter", number: 4 },
  { label: "OT", type: "overtime", number: 1 },
];
const summaryColumns = [
  { label: "Half-time", key: "firstHalf" },
  { label: "Second Half", key: "secondHalf" },
  { label: "Match Result", key: "totalScore" },
];

const BasketballResultTable = ({
  leagues,
  combineScores,
}: {
  leagues: ResultLeague[];
  combineScores?: boolean;
}) => (
  <PeriodResultTable
    leagues={leagues}
    periodColumns={periodColumns}
    summaryColumns={summaryColumns}
    combineScores={combineScores}
  />
);

export default BasketballResultTable;
